<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row class="table-header">
          <el-col>
            <el-tooltip
              effect="dark"
              content="创建公司"
              placement="top-start"
              v-if="
                userPermissions.indexOf('company_create') != -1 &&
                buttonType == 'icon'
              "
            >
              <el-button
                type="primary"
                size="medium"
                icon="iconfont icon-tianjiacaidan2"
                @click="addButton(0)"
              ></el-button>
            </el-tooltip>
            <el-button
              type="primary"
              size="medium"
              icon="iconfont"
              v-if="
                userPermissions.indexOf('company_create') != -1 &&
                buttonType == 'text'
              "
              @click="addButton(0)"
              >创建公司
            </el-button>
          </el-col>
        </el-row>
        <el-row class="table-search">
          <el-form
            size="medium"
            :inline="true"
            :model="searchCondition"
            class="demo-form-inline"
          >
            <el-form-item label="">
              <el-input
                v-model="searchCondition.name"
                placeholder="输入公司名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
            <div class="table-right">
              <el-select
                v-model="value"
                placeholder="请选择导出类型"
                @change="selectData"
                class="select-box"
                size="medium"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-button
                :loading="downloadLoading"
                style="margin: 0 0 20px 20px"
                type="primary"
                size="medium"
                icon="el-icon-document"
                @click="handleDownload"
              >
                导出
              </el-button>
            </div>
          </el-form>
        </el-row>
        <!-- <el-row>
          <div class="table-right">
            <el-select v-model="value" placeholder="请选择导出类型" @change="selectData" class="select-box" size="medium">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-button :loading="downloadLoading" style="margin:0 0 20px 20px;" type="primary" size="medium" icon="el-icon-document" @click="handleDownload">
              导出
            </el-button>
          </div>
        </el-row> -->
        <ApeTable
          ref="apeTable"
          :data="companyList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column
            slot="first-column"
            align="center"
            label="公司名称"
            width="300"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.id"
                placement="top"
              >
                <div>{{ scope.row.name }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            slot="first-column"
            prop="money"
            align="center"
            sortable
            label="公司税率"
          >
            <template slot-scope="scope">
              <div class="tag-group">
                <el-tag type="warning">{{ scope.row.alias_rate }}</el-tag>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            slot="first-column"
            prop="status"
            align="center"
            label="状态"
          >
            <template slot-scope="scope">
              <div class="tag-group">
                {{
                  scope.row.status == 0
                    ? "待审核"
                    : scope.row.status == 1
                    ? "审核通过"
                    : scope.row.status == 2
                    ? "审核拒绝"
                    : ""
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="buttonType == 'text'"
            align="center"
            width="380"
            label="操作"
          >
            <template slot-scope="scope">
              <span>
                <el-button
                  size="mini"
                  type="default"
                  v-if="userPermissions.indexOf('company_rate') != -1"
                  @click="setTaxRate(scope.row.id, scope.row.alias_rate)"
                >
                  设置税率</el-button
                >
                <el-button
                  size="mini"
                  type="default"
                  v-if="userPermissions.indexOf('company_subaccount') != -1"
                  @click="generateSubAccount(scope.row.id, scope.row.name)"
                  >生成子账号</el-button
                >
                <!-- <el-button
                  size="mini"
                  type="default"
                  v-if="userPermissions.indexOf('company_recharge') != -1"
                  @click="serviceRecharge(scope.row.id, scope.row.account)"
                >测试服务充值</el-button> -->
                <el-button
                  size="mini"
                  type="default"
                  v-if="userPermissions.indexOf('company_edit') != -1"
                  @click="editButton(scope.row.id)"
                  >编辑</el-button
                >
                <el-popover
                  v-if="userPermissions.indexOf('company_delete') != -1"
                  placement="top"
                  v-model="scope.row.visible"
                >
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      type="text"
                      size="mini"
                      @click="scope.row.visible = false"
                      >取消</el-button
                    >
                    <el-button
                      type="danger"
                      size="mini"
                      @click="deleteButton(scope.row.id)"
                      >确定</el-button
                    >
                  </div>
                  <el-button slot="reference" type="danger" size="mini"
                    >删除</el-button
                  >
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <el-dialog
      width="35%"
      :title="isTax ? '设置税率' : '生成子账号'"
      :before-close="handleOuterClose"
      :visible.sync="outerVisible"
    >
      <el-form
        :model="taxRateData"
        label-position="left"
        label-width="96px"
        v-if="this.isTax"
      >
        <el-form-item label="当前税率">
          <div>{{ this.rate }}</div>
        </el-form-item>
        <el-form-item label="设置税率" prop="taxRate">
          <el-input
            v-model="taxRateData.taxRate"
            maxlength="4"
            style="width: 200px"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-form>
      <el-form v-if="!this.isTax">
        <el-form-item
          label="服务公司"
          prop="settlementId"
          :rules="[
            { required: true, message: '请选择服务公司', trigger: 'blur' },
          ]"
        >
          <el-select
            filterable
            v-model="taxRateData.settlementId"
            placeholder="请选择服务公司"
            @change="settlementChange"
            class="settlement-select"
          >
            <el-option
              v-for="item in settlementList"
              :key="item.id"
              :label="item.name + '  (' + item.bank_name + ')'"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="bank-wrapper">
          <el-form-item label="来款银行" :class="!isTax ? 'set' : ''">
            <el-select
              v-model="taxRateData.in_bank_code"
              clearable
              filterable
              placeholder="请选择"
              style="width: 422px"
            >
              <el-option
                v-for="item in this.bankCodeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开户名" :class="!isTax ? 'set' : ''">
            <el-input v-model="taxRateData.account_name"></el-input>
          </el-form-item>
          <div class="form-alert bank">（微信必填，其他选填）</div>
          <el-form-item label="来款银行帐号" :class="!isTax ? 'set' : ''">
            <el-input v-model="taxRateData.in_bank_no"></el-input>
          </el-form-item>
          <div class="form-alert bank">
            （网商开户可选填，盛京银行开户必填）
          </div>
        </div>
        <el-form-item style="margin-top: 10px">
          <el-checkbox-group
            v-model="acct_typeList"
            @change="changeAcctType"
            class="change-acct"
          >
            <el-checkbox label="是否生成服务费账户"></el-checkbox>
            <div class="form-alert manage">（此处管理员操作，勿选）</div>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <el-dialog
        width="35%"
        :close-on-click-modal="false"
        title="系统提示"
        :visible.sync="innerVisible"
        :before-close="handleInnerClose"
        append-to-body
      >
        <div class="accountTips">
          <el-alert
            :title="
              this.isColorChange ? '抱歉子账号创建失败' : '子账号创建成功'
            "
            :type="this.isColorChange ? 'error' : 'success'"
            :closable="false"
            show-icon
          >
          </el-alert>
        </div>
        <el-form class="sub-account">
          <el-form-item label="打款账户:">{{ this.account }}</el-form-item>
          <el-form-item label="打款开户行:">{{ this.bankName }}</el-form-item>
          <el-form-item label="打款户名:">{{ this.accountName }}</el-form-item>
          <el-form-item label="子账号ID:">{{ this.subAccountID }}</el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="checkInner" size="medium"
            >关闭
          </el-button>
        </div>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelOuter" size="medium">取 消</el-button>
        <el-button
          type="primary"
          @click="checkOuter"
          size="medium"
          :disabled="this.isShowOuterCheckBtn"
          >确定
        </el-button>
      </div>
    </el-dialog>

    <ModalDialog
      :dialogData="dialogData"
      @dialogConfirm="handleConfirm"
      @dialogClose="dialogClose"
    >
      <template slot="content">
        <el-form
          :model="serviceRechargeData"
          ref="serviceRechargeForm"
          label-width="96px"
        >
          <el-form-item label="设置充值金额" prop="taxRate">
            <el-input v-model="serviceRechargeData.money" style="width: 200px">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
/* eslint-disable */
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import TreeTable from "@/components/TreeTable";
import ApeUploader from "@/components/ApeUploader";
import ModalDialog from "@/components/ModalDialog";
import ScreeCompany from "@/components/ScreeCompany.vue";
import { mapGetters, mapState } from "vuex";
import api from "@/api";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    TreeTable,
    ApeUploader,
    ModalDialog,
    ScreeCompany,
  },
  data() {
    return {
      bankCodeList: [],
      dialogData: {
        visible: false,
        title: "",
        width: "25%",
        loading: true,
        modal: false,
      },
      serviceRechargeData: {
        money: "",
        company_id: "",
      },
      options: [
        {
          value: "xlsx",
          label: "xlsx",
        },
        {
          value: "csv",
          label: "csv",
        },
        {
          value: "txt",
          label: "txt",
        },
      ],
      value: "xlsx",
      bookType: "xlsx", //导出表格类型
      downloadLoading: false, // 搜索条件
      // element的cascader的props值
      cascaderProps: {
        label: "display_name",
        value: "id",
      },
      searchCategory: [],
      // 搜索条件
      searchCondition: {},
      loadingStaus: true,
      columns: [
        // {
        //   title: "ID",
        //   value: "id",
        //   header_align: "center",
        //   align: "center",
        //   width: 170
        // },
        // {
        //   title: "公司名称",
        //   // header_align: "center",
        //   operation: true, // 作为展开操作列
        //   // align: "center",
        //   value: 'name'
        // },
        // {
        //   title: "公司税率",
        //   header_align: "center",
        //   align: "center",
        //   value: 'alias_rate'
        // },
        // {
        //   title: "开放平台配置",
        //   value: "openapi_remark",
        //   width: 300,
        //   color: '#DD4A42',
        //   value: [
        //     {label:'appKey：',value:'openapi_id'},
        //     {label:'IP白名单：',value:'alias_openapi_restriction'},
        //     // {label:'服务公司：',value:'openapi_remark'},
        //   ],
        // },
        // {
        //   title: '公司法人',
        //   value: 'legal_person',
        // },
        // {
        //   title: "状态",
        //   value: "status",
        //   header_align: "center",
        //   align: "center",
        //   width: 100,
        // },
        {
          title: "创建时间",
          header_align: "center",
          align: "center",
          value: "created_at",
        },
      ],
      // 表格列表数据
      companyList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      // 已上传文件列表
      uploadFileList: [],
      // 表单验证
      rules: {
        title: [{ required: true, message: "输入标题", trigger: "blur" }],
        type: [{ required: true, message: "选择类型", trigger: "blur" }],
        is_new_win: [
          { required: true, message: "选择打开发方式", trigger: "blur" },
        ],
        is_show: [{ required: true, message: "选择状态", trigger: "blur" }],
        image: [
          {
            required: true,
            message: "上传图片",
            trigger: "blur",
            validator: this.apeUploaderVerify,
          },
        ],
      },
      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: "正在加载中……",
        // direction: 'right',
        title: "",
        width_height: "640px",
        show_footer: false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 附件列表
      attachmentList: [],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: "标题",
          value: "title",
        },
      ],
      // 添加附件
      dialogData: {
        visible: false,
        title: "",
        width: "24%",
        loading: true,
        modal: false,
      },
      // 附件表单内容
      formData: {},
      // 附件添加表单验证
      dialogRules: {
        title: [{ required: true, message: "输入标题", trigger: "blur" }],
      },
      // 附件类型
      attachmentType: [
        "application/pdf",
        "application/caj",
        "",
        "application/zip",
        "application/rar",
        "application/doc",
      ],
      // 已上传附件列表
      attachmentUploadFileList: [],
      // 当前需要操作附件的文章id
      currentCompanyId: 0,
      outerVisible: false, //控制外层弹窗显示/隐藏
      innerVisible: false, //控制内层弹窗显示/隐藏
      taxRateData: {
        settlementId: "", //服务公司id
        company_id: "",
        taxRate: "",
        in_bank_code: "",
        in_bank_no: "",
        account_name: "",
      },
      isTax: true, //是否显示税率弹窗
      showPopover: false, //是否显示确定更改Popover弹出框
      // settlementId: "", //服务公司id
      acct_typeList: "", //是否生成服务费账户
      acct_type: 0,
      rate: 0, //当前税率
      company_id: "",
      company_name: "",
      accountName: "",
      bankName: "",
      subAccountID: "",
      isColorChange: false,
      account: "",
      isShowOuterCheckBtn: true, //外层弹窗按钮是否可用
    };
  },
  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    ...mapState({
      // settlementList: state => state.switchInfo.settlementList
    }),
  },
  watch: {
    "$route.matched": function (n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
    "taxRateData.taxRate": function (v) {
      if (v) {
        this.isShowOuterCheckBtn = false;
      } else {
        this.isShowOuterCheckBtn = true;
      }
    },
    "taxRateData.settlementId": function (v) {
      if (v) {
        this.isShowOuterCheckBtn = false;
      } else {
        this.isShowOuterCheckBtn = true;
      }
    },
    "serviceRechargeData.money": function (v) {
      if (v) {
        this.dialogData.loading = false;
      } else {
        this.dialogData.loading = true;
      }
    },
    acct_type: function (v) {
      if (v) {
        this.acct_typeList = true;
      } else {
        this.acct_typeList = false;
      }
    },
  },
  methods: {
    //获取银行编码
    async getBankCode() {
      let result = await this.$api.getBankCode();
      if (result) {
        this.bankCodeList = result;
        console.log(this.bankCodeList, "this.bankCodeList");
      } else {
      }
    },
    changeAcctType(e) {
      if (e) {
        this.acct_type = 1;
      } else {
        this.acct_type = 0;
      }
    },
    //导出
    async handleDownload() {
      this.isExport = true;
      this.downloadLoading = true;
      let list = await this.init("export");
      import("@/excel/Export2Excel").then((excel) => {
        const tHeader = ["公司名称", "公司税率", "状态", "创建时间"];
        const data = this.formatJson(list);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `商户${time}`;
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let { name, alias_rate, status_alias, created_at } = v;
        return [name, alias_rate, status_alias, created_at];
      });
    },
    // 选择导出类型
    selectData(e) {
      this.bookType = e;
    },
    /*生成子账号*/
    generateSubAccount(id, name) {
      this.company_id = id;
      this.company_name = name;
      this.outerVisible = true;
      this.isTax = false;
      this.getBankCode();
    },
    /*子账号cahnge事件*/
    getSubAccount(val) {
      console.log(val, "val");
    },
    /*设置税率*/
    setTaxRate(id, rate) {
      if (rate) {
        this.rate = rate;
      }
      this.taxRateData.company_id = id;
      this.outerVisible = true;
      this.isTax = true;
    },
    /*取消外层弹窗*/
    cancelOuter() {
      this.outerVisible = false;
      this.acct_type = 0;
      console.log("关闭", this.acct_type);
      if (this.isTax) {
        this.taxRateData = {};
      } else {
        this.taxRateData.settlementId = "";
        this.taxRateData.in_bank_code = "";
        this.taxRateData.in_bank_no = "";
      }
    },
    // 生成子账号表单
    async sonAccountForm() {
      this.settlementList.forEach((item) => {
        if (item.id == this.taxRateData.settlementId) {
          this.accountName = item.name;
          this.bankName = item.bank_name;
        }
      });
      let { settlementId, in_bank_code, in_bank_no, account_name } =
        this.taxRateData;
      let result = await this.$api.createSubAccount(
        this.company_id,
        this.company_name,
        settlementId,
        this.acct_type,
        in_bank_code,
        in_bank_no,
        account_name
      );
      if (result) {
        this.subAccountID = result.uid;
        this.account = result.account;
        this.isColorChange = false;
      } else {
        this.isColorChange = true;
      }
    },
    /*确定外层弹窗*/
    checkOuter() {
      if (this.isTax) {
        this.rateFormSubmit();
        this.innerVisible = false;
      } else {
        this.sonAccountForm();
        this.outerVisible = false;
        this.innerVisible = true;
        this.acct_type = 0;
      }
    },
    // 确定内层弹框
    checkInner() {
      this.innerVisible = false;
      this.taxRateData.settlementId = "";
      this.taxRateData.in_bank_code = "";
      this.taxRateData.in_bank_no = "";
    },
    /*点击外层弹框小×*/
    handleOuterClose() {
      this.outerVisible = false;
      if (this.isTax) {
        this.taxRateData = {};
      } else {
        this.taxRateData.settlementId = "";
        this.taxRateData.in_bank_code = "";
        this.taxRateData.in_bank_no = "";
        this.acct_type = 0;
      }
    },
    //点击内层弹框小×
    handleInnerClose() {
      this.outerVisible = false;
      this.innerVisible = false;
      this.taxRateData.settlementId = "";
      this.taxRateData.in_bank_code = "";
      this.taxRateData.in_bank_no = "";
      this.taxRateData = {};
    },

    // 提交税率表单
    async rateFormSubmit() {
      let company_id = this.taxRateData.company_id,
        rate = this.taxRateData.taxRate;
      let result = await this.$api.getRate(company_id, rate);
      if (result) {
        this.$message({
          message: "设置税率成功",
          type: "success",
        });
        this.init();
      } else {
        this.$message.error("设置税率失败，请稍后重试");
      }
      this.outerVisible = false;
      this.taxRateData = {};
    },
    //服务公司选择
    async settlementChange(v) {
      if (v) {
        this.taxRateData.settlementId = v;
      }
    },
    //测试服务充值
    serviceRecharge(id, account) {
      this.dialogData.visible = true;
      this.dialogData.title = "测试服务充值";
      this.serviceRechargeData.company_id = id;
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs["serviceRechargeForm"].validate((valid) => {
        if (valid) {
          if (this.serviceRechargeData.money) {
            console.log("修改金额接口");
            this.createRecharge();
          }
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
    },
    // 处理模态框，关闭事件
    dialogClose() {
      console.log("dialogClose");
      this.serviceRechargeData = {};
      this.dialogData.visible = false;
    },
    async createRecharge() {
      let { money, company_id } = this.serviceRechargeData;
      let channel_account = this.mxSettlementId;
      let result = await this.$api.createRecharge(
        money,
        channel_account,
        company_id
      );
      if (result.is_success == "T") {
        this.dialogData.visible = false;
        this.$message({
          showClose: true,
          message: result.memo,
          type: "success",
        });
        this.serviceRechargeData = {};
        this.init();
      }
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 响应添加按钮
    async addButton() {
      this.$router.push(this.$route.path + "/create");
    },
    // 响应详情按钮
    async viewButton(id) {
      this.$router.push(this.$route.path + "/" + id + "/view");
    },
    // 响应编辑按钮
    async editButton(id) {
      this.$router.push(this.$route.path + "/" + id + "/edit");
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteCompany(id);
      if (info == "ok") {
        this.$nextTick(() => {
          this.init("del");
        });
      } else {
        this.$message.error(info);
      }
    },
    // 文章添加附件
    companyAttachment(row) {
      this.currentCompanyId = row.id;
      this.drawerData.loading_text = "正在加载中……";
      this.drawerData.visible = true;
      this.drawerData.title = "附件列表（" + row.title + "）";
      this.initCompanyAttachmentList();
      this.$nextTick(() => {
        this.drawerData.loading = false;
      });
    },
    // 处理抽屉关闭
    drawerClose() {
      this.drawerData.visible = false;
      this.drawerData.loading = true;
    },
    // 初始化文章列表
    async init(type) {
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "export") {
        pagingInfo.page_size = 50000;
      } else {
        this.loadingStaus = true;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { list, pages } = await this.$api.getCompanyList(searchCondition);
      if (type == "export") {
        return list;
      } else {
        this.companyList = [];
        this.$nextTick(() => {
          this.companyList = list;
        });
        this.pagingData.total = pages.total;
        this.offset = pages.offset;
        this.loadingStaus = false;
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.id) {
        condition.id = this.searchCondition.id;
      }
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name;
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0];
        condition.end_time = this.searchCondition.time_value[1];
      }

      return condition;
    },
    // 获取文章分类列表
    async getCategoryList() {
      // 获取文章分类列表
      let { list } = await this.$api.getCompanyCategoryList();
      this.searchCategory = list;
    },
    // 初始化文件附件列表
    async initCompanyAttachmentList() {
      let list = await this.$api.getCompanyAttachment(this.currentCompanyId);
      this.attachmentList = list;
    },
    // 附件上传成功回调
    handleAttachmentUploadSuccess(file, fileList) {
      this.formData.attachment_id = file.id;
      this.attachmentUploadFileList = fileList;
    },
    // 附件删除回调
    handleAttachmentUploadRemove(file, fileList) {
      this.formData.attachment_id = 0;
      this.attachmentUploadFileList = fileList;
    },
    // form数据提交，请求接口,文章附件
    // async formSubmit() {
    //   this.dialogData.loading_text = "正在提交中……";
    //   this.dialogData.loading = true;
    //   this.formData.company_id = this.currentCompanyId;
    //   let id = await this.$api.saveCompanyAttachment(this.formData);
    //   this.$nextTick(() => {
    //     this.dialogClose();
    //   });
    //   this.$nextTick(() => {
    //     if (id) {
    //       this.initCompanyAttachmentList();
    //     }
    //   });
    //   this.$nextTick(() => {
    //     this.$message.success("保存成功!");
    //   });
    // },
    // // 处理模态框，确定事件
    // handleConfirm() {
    //   // 调用组件的数据验证方法
    //   this.$refs["companyAttacmentForm"].validate(valid => {
    //     if (valid) {
    //       this.formSubmit();
    //     } else {
    //       this.$message.error("数据验证失败，请检查必填项数据！");
    //     }
    //   });
    // },
    // 处理模态框，关闭事件
    // dialogClose() {
    //   this.dialogData.visible = false;
    //   this.dialogData.loading = true;
    //   this.formData = {};
    //   this.attachmentUploadFileList = [];
    // },
    // 响应添加附件按钮
    async addAttachment() {
      this.dialogData.visible = true;
      this.dialogData.loading = false;
      this.dialogData.title = "添加附件";
    },
    // 相应删除文章附件按钮
    async deleteCompanyAttachmentButton(id) {
      let info = await this.$api.deleteCompanyAttachment(id);
      if (info == "ok") {
        this.$nextTick(() => {
          this.initCompanyAttachmentList();
        });
      } else {
        this.$message.error(info);
      }
    },
  },

  async created() {
    this.settlementList = await api.getSettlementCategoryList();
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.table-header {
  margin-bottom: 12px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0px;
  margin-right: 12px;
}

.show-color {
  background-color: #F5F7FA;
}

.el-button + .el-button {
  margin-left: 0;
}

.table-right {
  float: right;
}

.select-box {
  width: 100px;
}

.el-tag {
  font-size: 14px;
  line-height: 38px;
  height: 38px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

/deep/ .sub-account .el-form-item {
  margin-bottom: 0;
}

.accountTips {
  margin-bottom: 30px;
}

/deep/ .accountTips .el-alert--success.is-light {
  padding: 20px;
}

/deep/ .el-dialog__body {
  padding: 30px 55px;
}

/deep/ .el-form.sub-account {
  padding: 0 50px;
}

/deep/ .accountTips .el-alert__title {
  font-size: 20px;
  padding-left: 10px;
}

/deep/ .accountTips .el-alert__icon {
  font-size: 20px;
}

/deep/ .set .el-form-item__content {
  margin-left: 96px;
}

.settlement-select {
  margin-left: 20px;
  width: 269px;
}

.form-alert {
  color: #f56c6c;
  font-size: 14px;
  margin-top: -5px;
}

.bank {
  padding: 10px 0 0px 0;
}

/deep/ .form-alert .el-alert__content.el-alert--warning.is-light {
  background: #fff !important;
}

.change-acct {
  display: flex;
}

.manage {
  margin-top: 0;
  margin-left: 10px;
}

.bank-wrapper {
  padding: 24px 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
